(function() {
  'use strict';

  if (window.__rhNewsVignetteScope) return;

  var currentUrl = new URL(window.location.href);
  var newsPathPattern = /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?(?:pages\/(?:drone-news|lauthomas)(?:\/|$)|blogs\/industry-hotspot-analysis(?:\/|$))/i;

  function isNewsUrl(href) {
    if (!href || href.charAt(0) === '#') return true;

    try {
      var destination = new URL(href, currentUrl.href);
      return destination.origin === currentUrl.origin && newsPathPattern.test(destination.pathname);
    } catch (error) {
      return false;
    }
  }

  function scopeAnchor(anchor) {
    if (!anchor || typeof anchor.getAttribute !== 'function') return;

    var href = anchor.getAttribute('href');
    if (!href || href.charAt(0) === '#') return;

    if (!isNewsUrl(href)) {
      anchor.setAttribute('data-google-vignette', 'false');
      anchor.setAttribute('data-rh-vignette-boundary', 'non-news');
      return;
    }

    if (anchor.getAttribute('data-rh-vignette-boundary') === 'non-news') {
      anchor.removeAttribute('data-google-vignette');
      anchor.removeAttribute('data-rh-vignette-boundary');
    }
  }

  function scopeLinks(root) {
    if (!root) return;
    if (typeof root.matches === 'function' && root.matches('a[href]')) scopeAnchor(root);
    if (typeof root.querySelectorAll !== 'function') return;
    root.querySelectorAll('a[href]').forEach(scopeAnchor);
  }

  function start() {
    scopeLinks(document);

    if (!document.documentElement || typeof MutationObserver !== 'function') return;
    new MutationObserver(function(records) {
      records.forEach(function(record) {
        if (record.type === 'attributes') {
          scopeAnchor(record.target);
          return;
        }
        record.addedNodes.forEach(scopeLinks);
      });
    }).observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['href']
    });
  }

  window.__rhNewsVignetteScope = {
    isNewsUrl: isNewsUrl,
    scopeLinks: scopeLinks
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
